export default __webpack_public_path__ + "static/bariol_serif_regular_italic-webfont-38a235b85217680ff2ff870537d28732.woff";